export function modelosveiculosInRequest(params = {}) {
  return {
    type: '@modelosveiculo/MODELOSVEICULOS_IN_REQUEST',
    payload: { params },
  };
}

export function findModelosVeiculo(idmodeloveiculo) {
  return {
    type: '@modelosveiculo/FIND_MODELOSVEICULO',
    payload: { idmodeloveiculo },
  };
}

export function failedRequest() {
  return {
    type: '@modelosveiculo/FAILED_REQUEST',
  };
}

export function deleteModelosVeiculo(idmodeloveiculo, params) {
  return {
    type: '@modelosveiculo/DELETE_MODELOSVEICULO',
    payload: { idmodeloveiculo, params },
  };
}

export function updateModelosVeiculo(modelosveiculo, params) {
  return {
    type: '@modelosveiculo/UPDATE_MODELOSVEICULO',
    payload: { modelosveiculo, params },
  };
}

export function storeModelosVeiculo(modelosveiculo, params) {
  return {
    type: '@modelosveiculo/STORE_MODELOSVEICULO',
    payload: { modelosveiculo, params },
  };
}

export function successInRequest(
  modelosveiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@modelosveiculo/SUCCESS_IN_REQUEST',
    payload: { modelosveiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(modelosveiculo) {
  return {
    type: '@modelosveiculo/SUCCESS_REQUEST',
    payload: { modelosveiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@modelosveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@modelosveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
